import React, { useState, useEffect } from 'react';
import { Grid, Paper, Typography, Button, IconButton, Table, TableBody, TableCell, TableContainer, TableHead, TableRow, CircularProgress } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { fetchReceipts, deleteReceipts } from '../api'; // Importing API methods
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

function ManageReceipts() {
  const [records, setRecords] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const navigate = useNavigate();

  // Fetch records from API on component mount
  useEffect(() => {
    const getRecords = async () => {
      try {
        setLoading(true); // Show loading spinner
        const response = await fetchReceipts(); // Fetch the list of records
        setRecords(response.data); // Store records in state
        setLoading(false);
      } catch (err) {
        setError('Failed to fetch records');
        setLoading(false);
      }
    };

    getRecords();
  }, []);

  // Handle Edit action (navigate to the edit page with record ID)
  const handleEdit = (id) => {
    navigate(`/edit/${id}`); // Assuming the route for editing is '/edit/:id'
  };

  // Handle Delete action
  const handleDelete = async (id) => {
    if (window.confirm('Are you sure you want to delete this record?')) {
      try {
        setLoading(true);
        await deleteReceipts(id);  // Call API to delete the record
        setRecords(records.filter(record => record.id !== id));  // Remove record from state
        setLoading(false);
      } catch (err) {
        setError('Failed to delete record');
        setLoading(false);
      }
    }
  };

  return (
    <Grid container justifyContent="center" sx={{ mt: 4 }}>
      <Grid item xs={12} sm={10} md={8} lg={6}>
        <Paper elevation={6} sx={{ p: 3 }}>
          <Typography variant="h5" align="center" gutterBottom>
            Manage Records
          </Typography>
          
          {error && <Typography color="error" align="center" sx={{ mb: 2 }}>{error}</Typography>}
          
          {/* Button to navigate to the dynamic form (for creating new record) */}
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate('/form')}
            sx={{ mb: 2 }}
            fullWidth
          >
            Add New Record
          </Button>

          {/* Display records in a table */}
          {loading ? (
            <CircularProgress />
          ) : (
            <TableContainer component={Paper}>
              <Table>
                <TableHead>
                  <TableRow>
                    <TableCell>ID</TableCell>
                    <TableCell>New Value</TableCell>
                    <TableCell>Actions</TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {records.map((record) => (
                    <TableRow key={record.id}>
                      <TableCell>{record.ID}</TableCell>
                      <TableCell>{record.new}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleEdit(record.id)} color="primary">
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleDelete(record.id)} color="error">
                          <DeleteIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Paper>
      </Grid>
    </Grid>
  );
}

export default ManageReceipts;
